<template>
  <custom-dialog
    :title="$t('asm_offline_setting_dialog.li_xian_she_zhi')"
    :visible="visible"
    v-on="$listeners"
    width="1000px"
    class="offline-setting-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="info-content">
        <div class="item-title">{{ $t('asm_offline_setting_dialog.she_bei_xin_xi') }}</div>
        <div class="base-info">
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.chan_pin_xing_hao') }}：</div>
              <div class="val">{{info.productCode}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.ji_shen_hao') }}：</div>
              <div class="val">{{info.bodyNum}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.li_xian_tian_shu') }}：</div>
              <div class="val">{{info.offlineDays}}</div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.zu_lin_fang') }}：</div>
              <div class="val">{{info.customerName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.xiang_mu') }}：</div>
              <div class="val">{{info.locationName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.shou_hou_gong_si') }}：</div>
              <div class="val">{{info.afterServiceName}}</div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="key">{{ $t('asm_offline_setting_dialog.she_bei_di_zhi') }}：</div>
              <div class="val">{{info.currentLocation}}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="info-content">
        <div class="item-title">{{ $t('asm_offline_setting_dialog.li_xian_she_zhi') }}</div>
        <el-form
          label-position="top"
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item :label="$t('asm_offline_setting_dialog.yun_xu_li_xian')">
                <el-switch
                  v-model="form.allowOffline"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="15"
            v-if="form.allowOffline"
          >
            <el-col :span="24">
              <el-form-item
                :label="$t('asm_offline_setting_dialog.li_xian_bei_zhu')"
                prop="desc"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="form.desc"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_submit') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // fault - 故障列表  offlineDevice - 离线设备
    type: {
      type: String,
      default: 'fault'
    }
  },
  data() {
    return {
      form: {

        // 允许离线
        allowOffline: false,
        // 离线备注
        desc: '',
      },

    };
  },
  computed: {
    rules() {
      return {
        desc: {
          validator: this.checkDesc
        },

      };
    },
    info() {
      return this.model.data || {};
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {

    checkDesc(rule, value, cb) {
      const { allowOffline } = this.form;
      const desc = value.trim();
      if (allowOffline && !desc) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      cb();
    },

    closeDialog() {
      this.visible = false;
    },
    async onConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$postJSON(apis.DmsDeviceOfflineEditRemark, this.getReqData(), true);
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.closeDialog();
          this.$emit('success');
        }
      });
    },
    getReqData() {
      const ret = {
        auditOffline: this.form.allowOffline,
        auditOfflineRemark: this.form.allowOffline ? this.form.desc : '',
        deviceId: this.info.deviceId,
      };

      return ret;
    },
    initDialog() {
      const { auditOfflineRemark } = this.info;
      this.form.desc = auditOfflineRemark;

    },

  },
  created() { },
  mounted() {
    this.initDialog();

  },
};
</script>

<style lang="scss" scoped>
.offline-setting-dialog {
  .reason-container {
    .el-button {
      margin-bottom: 8px;
    }
  }
  .info-content {
    .key {
      float: left;
      line-height: 32px;
    }
    .val {
      overflow: hidden;
      line-height: 32px;
    }

    .btn-content {
      overflow: hidden;
      .btn-sel-device {
        float: left;
      }
    }
    // .tips {
    //   float: left;
    //   line-height: 32px;
    //   margin-left: 10px;
    // }
    &:nth-child(1) {
      .base-info {
        background: #f9f9f9;
        border-radius: 10px;
        padding: 10px;
        font-size: 12px;
        line-height: 26px;
        margin-top: 15px;
      }
    }
    &:nth-child(2) {
      margin-top: 20px;
    }
  }
}
</style>
